import { createSelector } from "reselect"
import { capitalize } from "lodash"
import { getViewType, getPortfolioName } from "modules/portfolio-root/selectors/portfolios"
import { getDisplayTypeName } from "./items"

const getStartDate = (_, props) => props.startDate
const getEndDate = (_, props) => props.endDate

export const getFileName = createSelector(
  [getPortfolioName, getViewType, getStartDate, getEndDate, getDisplayTypeName],
  (portfolioName, viewType, startDate, endDate, displayTypeName) => `${portfolioName} ${capitalize(viewType)} ${displayTypeName} ${startDate} - ${endDate}`,
)
